module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./FormulaView.js"));
	}, "formulaView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=formulaView!./src/pages/Shop/Formula/FormulaView.js
// module id = 1823
// module chunks = 367